import request from '@/utils/request'

const base = '/erp/open-api-monitor'

/**
 * 华住日志详情含大段 request/response 文本，不能用全局 parseSafe（正则会破坏字符串内的 JSON 片段）。
 */
function parseMonitorJson (data) {
  if (data == null || typeof data !== 'string') {
    return data
  }
  try {
    return JSON.parse(data, (key, value) => {
      if (key === 'id' && (typeof value === 'number' || typeof value === 'string')) {
        return String(value)
      }
      if (typeof value === 'number' && (value > Number.MAX_SAFE_INTEGER || value < Number.MIN_SAFE_INTEGER)) {
        return String(value)
      }
      return value
    })
  } catch (e) {
    return data
  }
}

const monitorTransformResponse = [function (data) {
  return parseMonitorJson(data)
}]

function monitorRequest (config) {
  return request({
    ...config,
    transformResponse: monitorTransformResponse
  })
}

export function getOpenApiMonitorConfig () {
  return monitorRequest({ url: base + '/config', method: 'get' })
}

export function listOpenApiCatalog () {
  return monitorRequest({ url: base + '/catalog', method: 'get' })
}

export function pageOpenApiCallLogs (params) {
  return monitorRequest({ url: base + '/call-log/page', method: 'get', params })
}

export function getOpenApiCallLogDetail (id) {
  return monitorRequest({
    url: base + '/call-log/detail',
    method: 'get',
    params: { id: id == null ? id : String(id) }
  })
}
